import BaseController from '../base_controller'

// Main SNP calculator controller: orchestrates lifecycle (after calculate, vessel added/removed)
// so js.haml only dispatches events and this controller runs the steps.
export default class extends BaseController {
  static targets = ['vesselForm', 'customLabelLineBreaker', 'customMvResultCell', 'formsWrapper', 'addVesselWrapper']
  static values = { reorderUrl: String }

  connect() {
    this.setupOrdering()
  }

  disconnect() {
    this.sortableWrapper?.sortable('destroy')
    this.sortableWrapper = null
  }

  setupOrdering() {
    if (!this.hasFormsWrapperTarget || !this.reorderUrlValue) return
    this.sortableWrapper = $(this.formsWrapperTarget)
    this.sortableWrapper.sortable({
      axis: 'x',
      cancel: '.vessel-placeholder, .calc-cell, #new-vessel-form, input[type="submit"], .fixed, .vessel-form-contents',
      items: '> .vessel-form',
      update: () => {
        $.post({ url: this.reorderUrlValue, data: { imos: this.vesselFormTargets.map(form => form.dataset.imo) } })
      }
    })
  }

  afterCalculate({ detail }) {
    if (!detail?.imo) return
    this.dispatch('syncCollapseStyles')
    if (typeof startTooltips === 'function') startTooltips()
    this.highlightCustomResult()
    const formEl = this.vesselFormTargets.find(el => el.dataset.imo === detail.imo)
    if (typeof startMarketValueModal === 'function') startMarketValueModal(formEl)
    if (typeof startGaugePointer === 'function') startGaugePointer()
    if (typeof initCalcCharts === 'function') initCalcCharts(window.$ ? window.$(formEl) : null)
    if (typeof clearFormFeedback === 'function') clearFormFeedback()
    if (formEl) formEl.querySelectorAll('.calc-cell input').forEach((i) => i.classList.remove('double-border'))
    this.dispatch('vesselsChanged')
  }

  vesselAdded({ detail }) {
    const { vesselHtml } = detail
    if (!this.hasFormsWrapperTarget) return
    if (this.hasAddVesselWrapperTarget) {
      this.addVesselWrapperTarget.insertAdjacentHTML('beforebegin', vesselHtml)
    } else {
      this.formsWrapperTarget.insertAdjacentHTML('beforeend', vesselHtml)
    }
    this.dispatch('syncCollapseStyles')
    this.dispatch('vesselsChanged')
    if (typeof startTooltips === 'function') startTooltips()
  }

  highlightCustomResult() {
    this.vesselFormTargets.forEach(form => this.dispatch('highlightCustomResult', { target: form }))
    this.syncCustomLabelHighlight()
  }

  syncCustomLabelHighlight() {
    const anyHighlighted = this.customMvResultCellTargets.some(el => el.classList.contains('custom-speed-cons'))
    this.customLabelLineBreakerTargets.forEach(el => el.classList.toggle('custom-speed-cons', anyHighlighted))
  }

  afterVesselRemoved({ detail }) {
    if (!detail?.imo) return
    const form = this.vesselFormTargets.find(el => el.dataset.imo === detail.imo)
    if (form) {
      bootstrap.Tooltip.getInstance(form)?.dispose()
      form.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        bootstrap.Tooltip.getInstance(el)?.dispose()
      })
      form.remove()
    }
    this.hideLoading()
    this.dispatch('vesselsChanged')
  }
}
